import {
  takeEvery, select, spawn
} from 'redux-saga/effects'
import {
  sectionChange as sectionChangeSelectors,
  routerMatch as routerMatchSelectors,
} from 'flux/selectors'
import {
  viewer as viewerActions,
  routerMatch as routerMatchActions,
  flyers as flyersActions,
} from 'flux/actions'
import { sendPostMessage } from 'utils'
import { flyerPath } from 'app/routes'


/**
 * @param {Object | null | undefined} sectionChangePayload
 */
function sendSectionChangePayload(sectionChangePayload) {
  if (!sectionChangePayload) return
  
  sendPostMessage('sectionChange', sectionChangePayload)
}

export function* sendFlyersSectionChange(contentHeight) {
  const messagePayload = {
    section: {
      name: 'flyers',
    },
    context: {
      flyers: {
        contentHeight,
      }
    },
  }

  sendPostMessage('sectionChange', messagePayload)
 
  yield null // yield null to satisfy the linter
}

export function* onSetFlyersPageContentHeight({ payload }) {
  if (!payload || typeof payload.flyersPageContentHeight !== 'number') return

  yield spawn(sendFlyersSectionChange, payload.flyersPageContentHeight)
}

export function* onUpdateRouterMatch({ payload }) {
  const { match } = payload
  if (!match) return

  const genericPayload = yield select(sectionChangeSelectors.selectGenericSectionChangePayload)
  
  sendSectionChangePayload(genericPayload)
}

export function* onViewerUpdate() {
  const routerMatch = yield select(routerMatchSelectors.selectRouterMatch)
  if (routerMatch.path !== flyerPath) return

  const flyerPayload = yield select(sectionChangeSelectors.selectFlyerSectionChangePayload)
  sendSectionChangePayload(flyerPayload, routerMatch?.url)
}

export default function* () {
  yield takeEvery(routerMatchActions.types.UPDATE_ROUTER_MATCH, onUpdateRouterMatch)
  yield takeEvery(viewerActions.types.UPDATE, onViewerUpdate)
  yield takeEvery(flyersActions.types.SET_FLYERS_PAGE_CONTENT_HEIGHT, onSetFlyersPageContentHeight)
}
